function getUrlParam(name){
    var urlpara = location.search;
    var par = {};
    if (urlpara != "") {
      urlpara = urlpara.substring(1, urlpara.length);
      var para = urlpara.split("&");
      var parname;
      var parvalue;
      for (var i = 0; i < para.length; i++) {
        parname = para[i].substring(0, para[i].indexOf("="));
        parvalue = para[i].substring(para[i].indexOf("=") + 1, para[i].length);
        par[parname] = parvalue;
      }
    }
    if(typeof (par[name]) != "undefined"){
      return par[name];
    }
    else{
      return null;
    }
  }

module.exports = {
  development: {
    dataurl: function(){
      // return '//reportapi.uat.emapd.com/'
      return '//reportapi-uat.eastmoney.com/'
    },
    quoteurl: function(){
      let env = getUrlParam('myenv') || '';
      if(env == 'prod') {
        return '//push2.eastmoney.com/'
      }
      return '//push2test.eastmoney.com/'
      // return '//push2-uatfj.eastmoney.com/'
    },
    quotehisurl: function(){
      // return '//push2test.eastmoney.com/'
      return '//push2his-uatfj.eastmoney.com/'
    },    
    dcfmurl: function(){
      return '//dcfm.eastmoney.com/' 
    }, 
    anoticeurl: function(){
      // return '//np-anotice-stock.eastmoney.com/'
      return '//np-anotice-stock-test.eastmoney.com/'
    },
    cnoticeurl: function(){
      return '//np-cnotice-stock-test.eastmoney.com/'
    },
    datacenter: function(){
      // return '//datacenter-web.eastmoney.com/'
      return '//testdatacenter.eastmoney.com/'
      // return '//betadatacenter.eastmoney.com/'
      let env = getUrlParam('myenv') || '';
      if(env == 'prod') {
        return '//datacenter-web.eastmoney.com/'
      }
      return '//betadatacenter.eastmoney.com/'
      // return '//testdatacenter.eastmoney.com/'
    },
    datacenter2: function(){
      // return '//datacenter-web.eastmoney.com/'
      return '//testdatacenter.eastmoney.com/'
      // return '//betadatacenter.eastmoney.com/'
      // let env = getUrlParam('myenv') || '';
      // if(env == 'prod') {
      //   return '//datacenter-web.eastmoney.com/'
      // }
      // return '//testdatacenter.eastmoney.com/'
    },
    soapi: function(){
      return '//searchapi.eastmoney.com/'
    }, 
    cmsdataapi: function(){
      return '//cmsdataapi.eastmoney.com/'
    },
    newsinfo: function(){
      return '//newsinfo.eastmoney.com/'
    },
    url: function(){
      return ''
    },
    cmsapi : function () {
      return '//np-listapi.eastmoney.com//'
    },
    futsseapi: function () {
      // return '//futsseapi.eastmoney.com/'
      return '//futssetest.eastmoney.com/'
    },
    futssstatic: function () {
      // return '//futsse-static.eastmoney.com/'
      return '//static.futssetest.eastmoney.com/'
    }
  },
  zptest: {
    dataurl: function(){
      // return '//reportapi.eastmoney.com/'
      // return '//reportapi.uat.emapd.com/'
      return '//reportapi-uat.eastmoney.com/'

    },
    quoteurl: function(){
      let env = getUrlParam('myenv') || '';
      if(env == 'prod') {
        return '//push2.eastmoney.com/'
      }
      return '//push2test.eastmoney.com/'
      // return '//push2test.eastmoney.com/'
      // return '//push2-uatfj.eastmoney.com/'
    },
    quotehisurl: function(){
      // return '//push2test.eastmoney.com/'
      return '//push2his-uatfj.eastmoney.com/'
    }, 
    dcfmurl: function(){
      return '//dcfm.eastmoney.com/'
    },
    anoticeurl: function(){
      return '//np-anotice-stock-test.eastmoney.com/'
    },
    cnoticeurl: function(){
      // return '//np-cnotice-stock-test.emapd.com/'
      return '//np-cnotice-stock-test.eastmoney.com/'
    },
    datacenter: function(){
      return '//testdatacenter.eastmoney.com/'
      // return '//betadatacenter.eastmoney.com/'
      // return '//datacenter-web.eastmoney.com/'
      let env = getUrlParam('myenv') || '';
      if(env == 'prod') {
        return '//datacenter-web.eastmoney.com/'
      }
      return '//betadatacenter.eastmoney.com/'
      // return '//testdatacenter.eastmoney.com/'
    },
    datacenter2: function(){
      // return '//datacenter-web.eastmoney.com/'
      return '//testdatacenter.eastmoney.com/'
      // return '//betadatacenter.eastmoney.com/'
      // let env = getUrlParam('myenv') || '';
      // if(env == 'prod') {
      //   return '//datacenter-web.eastmoney.com/'
      // }
      // return '//testdatacenter.eastmoney.com/'
    },
    soapi: function(){
      return '//searchapi.eastmoney.com/'
    },    
    cmsdataapi: function(){
      return '//cmsdataapi.eastmoney.com/'
    },
    newsinfo: function(){
      return '//newsinfo.eastmoney.com/'
    },
    url: function(){
      return ''
    },
    cmsapi : function () {
      return '//np-listapi.eastmoney.com//'
    },
    futsseapi: function () {
       return '//futssetest.eastmoney.com/'
      // return '//futsseapi.eastmoney.com/'
    },
    futssstatic: function () {
      // return '//futsse-static.eastmoney.com/'
      return '//static.futssetest.eastmoney.com/'
    }
  },
  gray: {
    dataurl: function(){
      return '//reportapi.eastmoney.com/'
    },
    quoteurl: function(){
      return '//push2.eastmoney.com/'
    },
    quotehisurl: function(){
      return '//push2his-uatfj.eastmoney.com/'
    },      
    dcfmurl: function(){
      return '//dcfm.eastmoney.com/'
    },
    anoticeurl: function(){
      return '//np-anotice-stock.eastmoney.com/'
    },
    cnoticeurl: function(){
      return '//np-cnotice-stock.eastmoney.com/'
    },
    datacenter: function(){
      return '//graydatacenter.eastmoney.com/web/'
    },
    datacenter2: function(){
      return '//graydatacenter.eastmoney.com/web/'
    },
    soapi: function(){
      return '//searchapi.eastmoney.com/'
    },      
    cmsdataapi: function(){
      return '//cmsdataapi.eastmoney.com/'
    },
    newsinfo: function(){
      return '//newsinfo.eastmoney.com/'
    },
    url: function(){
      return ''
    },
    cmsapi : function () {
      return '//np-listapi.eastmoney.com//'
    },
    futsseapi: function () {
       return '//futssetest.eastmoney.com/'
      // return '//futsseapi.eastmoney.com/'
    },
    futssstatic: function () {
      // return '//futsse-static.eastmoney.com/'
      return '//static.futssetest.eastmoney.com/'
    }
  },
  production: {
    dataurl: function(){
      return '//reportapi.eastmoney.com/'
    },
    quoteurl: function(){
      return '//push2.eastmoney.com/'
    },
    quotehisurl: function(){
      return '//push2his.eastmoney.com/'
    },      
    dcfmurl: function(){
      return '//dcfm.eastmoney.com/'
    },
    anoticeurl: function(){
      return '//np-anotice-stock.eastmoney.com/'
    },
    cnoticeurl: function(){
      return '//np-cnotice-stock.eastmoney.com/'
    },
    datacenter: function(){
      return '//datacenter-web.eastmoney.com/'
    },
    datacenter2: function(){
      return '//datacenter-web.eastmoney.com/'
    },
    soapi: function(){
      return '//searchapi.eastmoney.com/'
    },      
    cmsdataapi: function(){
      return '//cmsdataapi.eastmoney.com/'
    },
    newsinfo: function(){
      return '//newsinfo.eastmoney.com/'
    },
    url: function(){
      return ''
    },
    cmsapi : function () {
      return '//np-listapi.eastmoney.com//'
    },
    futsseapi: function () {
      return '//futsseapi.eastmoney.com/'
    },
    futssstatic: function () {
      return '//futsse-static.eastmoney.com/'
    }
  },
  getParam: function(name){
    var urlpara = location.search;
    var par = {};
    if (urlpara != "") {
      urlpara = urlpara.substring(1, urlpara.length);
      var para = urlpara.split("&");
      var parname;
      var parvalue;
      for (var i = 0; i < para.length; i++) {
        parname = para[i].substring(0, para[i].indexOf("="));
        parvalue = para[i].substring(para[i].indexOf("=") + 1, para[i].length);
        par[parname] = parvalue;
      }
    }
    if(typeof (par[name]) != "undefined"){
      return par[name];
    }
    else{
      return null;
    }
  },
  getWebPath: function (name) {
    var env=(window.service&&service.ENV)||this.getParam('env');

    // env = "production"

    if (env&&this[env]) {
      return this[env][name]()
    }
    return this.production[name]()
  }
}

